import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [scroll, setScroll] = useState(false);
  const [activeClass, setActiveClass] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Handle scroll event
    const handleScroll = () => {
      let activeClass = window.scrollY === 0 ? 'top' : 'sticky';
      setActiveClass(activeClass);
    };

    window.addEventListener("scroll", handleScroll);

    // Reset scroll position on component mount
    window.scrollTo(0, 0);

    // Clean up scroll listener when component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Listen to route changes and reset scroll position
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <header className={`header-one ${activeClass}`} id="bar">
      <div className="main-menu">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-3 col-lg-3 d-flex col-5">
              <Link className="navbar-brand logo" to="/">
                <img src={require("../../assets/img/whatsinaname/Header-logo.png")} alt="donto" />
              </Link>
            </div>
            <div className="col-lg-9 col-md-9 d-none d-lg-block text-lg-right">
              <nav id="responsive-menu" className="menu-style-one">
                <ul className="menu-items">
                  <li><NavLink to="/">home</NavLink></li>
                  <li><span className="vCusMenu">About us</span>
                    <ul>
                      <li><NavLink to="/about-us" activeClassName="activeMenu">About us</NavLink></li>
                      <li><NavLink to="/news-events" activeClassName="activeMenu">News / Events</NavLink></li>
                      <li><NavLink to="/breathe-clinic" activeClassName="activeMenu">Breathe Clinic</NavLink></li>
                      <li><NavLink to="/virtual-tour" activeClassName="activeMenu">360<sup>0</sup>  Virtual Tour</NavLink></li>
                    </ul>
                  </li>
                 <li>
                        <span className="vCusMenu">Our Sleep Solution</span>
                        <ul>

                          <li>
                            <NavLink to="/treatment-packages" activeClassName="activeMenu">
                              Treatment Packages
                            </NavLink>
                          </li>

                          <li className="has-submenu">
                          <NavLink to="/services" activeClassName="activeMenu">
                            Services
                          </NavLink>

                          <ul>
                            <li>
                              <NavLink to="/services/sleep-study" activeClassName="activeMenu">
                                Sleep Study Analysis
                              </NavLink>
                            </li>
                          </ul>
                        </li>

                        </ul>
                      </li>
                  <li><NavLink to="/partner-with-us" activeClassName="activeMenu">Partner with us</NavLink></li>
                  <li><a href="https://sleeptherapeutics.in/blog/">Blog</a></li>
                  <li><NavLink to="/contact" activeClassName="activeMenu">Contact</NavLink></li>
                </ul>
              </nav>
            </div>
            <div className="col-md-9 col-sm-7 col-6 d-block d-lg-none vMenuBar">
              <nav className="navbar navbar-expand-lg text-right navbar-light mobile-nav">
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#mobilenav">
                  <span className="fal fa-bars" />
                </button>
              </nav>
            </div>
            <div className="collapse navbar-collapse mobile-menu" id="mobilenav">
              <ul className="navbar-nav vMobAdjest">
                <li data-toggle="collapse" data-target=".navbar-collapse">
                  <NavLink to="/" activeClassName="activeMenu">Home</NavLink>
                </li>
                <li data-toggle="collapse" data-target=".navbar-collapse">
                  <NavLink to="/about-us" activeClassName="activeMenu">About us</NavLink>
                </li>
                <li data-toggle="collapse" data-target=".navbar-collapse">
                  <NavLink to="/news-events" activeClassName="activeMenu">News / Events</NavLink>
                </li>
                <li data-toggle="collapse" data-target=".navbar-collapse">
                  <NavLink to="/breathe-clinic" activeClassName="activeMenu">Breathe Clinic</NavLink>
                </li>
                <li data-toggle="collapse" data-target=".navbar-collapse">
                  <NavLink to="/virtual-tour" activeClassName="activeMenu">360<sup>0</sup> Virtual Tour</NavLink>
                </li>
                <li data-toggle="collapse" data-target=".navbar-collapse">
                  <NavLink to="/treatment-packages" activeClassName="activeMenu">Treatment Packages</NavLink>
                </li>
                <li data-toggle="collapse" data-target=".navbar-collapse">
                  <NavLink to="/services" activeClassName="activeMenu">Services</NavLink>
                </li>
                <li data-toggle="collapse" data-target=".navbar-collapse">
                  <NavLink to="/partner-with-us" activeClassName="activeMenu">Partner with us</NavLink>
                </li>
                <li data-toggle="collapse" data-target=".navbar-collapse">
                  <a href="https://sleeptherapeutics.in/blog/">Blog</a>
                </li>
                <li data-toggle="collapse" data-target=".navbar-collapse">
                  <NavLink to="/contact" activeClassName="activeMenu">Contact</NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;